import { createFileRoute } from "@tanstack/react-router";

import { CoachQuestionnaireSubmissionsPage } from "src/pages/CoachQuestionnaireSubmissionsPage";

export const Route = createFileRoute(
  "/_auth/_coach/questionnaires/$questionnaireId/submissions/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <CoachQuestionnaireSubmissionsPage />;
}
